import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";
import { PRACTICES } from "../data/content";

const telHref = (phone) => `tel:+1${phone.replace(/[^0-9]/g, "")}`;

export const Practices = () => (
  <section id="practices" data-testid="practices-section" className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-36">
    <Reveal>
      <ChapterLabel number="03" label="Where I Practice" />
      <h2
        data-testid="practices-title"
        className="font-display mt-6 text-3xl font-light tracking-tight text-[#1B3A5C] sm:text-4xl lg:text-5xl"
      >
        Four locations, across the island
      </h2>
    </Reveal>

    <div className="mt-14 grid gap-6 md:grid-cols-2 lg:mt-20 lg:gap-8">
      {PRACTICES.map((p, i) => (
        <Reveal key={p.id} delay={0.1 + i * 0.12}>
          <article
            data-testid={`practice-card-${p.id}`}
            className="group flex h-full flex-col border border-[#C9A66B]/25 bg-white p-8 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-[#C9A66B]/60 lg:p-10"
          >
            <div className="flex items-start justify-between gap-4">
              <h3 className="font-display text-lg font-normal leading-snug text-[#1B3A5C] lg:text-xl">
                {p.name}
              </h3>
              <span className="shrink-0 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C9A66B]">
                {p.city}
              </span>
            </div>

            <div className="mt-6 flex items-start gap-3 text-sm text-[#555]">
              <MapPin size={15} strokeWidth={1.5} className="mt-0.5 shrink-0 text-[#C9A66B]" />
              <div>
                <p data-testid={`practice-address-${p.id}`}>{p.address}</p>
                {p.detail && <p className="mt-1 text-[13px] italic text-[#888]">{p.detail}</p>}
              </div>
            </div>

            <div className="mt-4 flex flex-col gap-2">
              {p.phones.map((phone) => (
                <a
                  key={phone}
                  href={telHref(phone)}
                  data-testid={`practice-phone-${p.id}-${phone.replace(/[^0-9]/g, "").slice(-4)}`}
                  className="flex w-fit items-center gap-3 text-sm text-[#2D2D2D] transition-colors duration-300 hover:text-[#C9A66B]"
                >
                  {phone.includes("WhatsApp") ? (
                    <MessageCircle size={15} strokeWidth={1.5} className="shrink-0 text-[#C9A66B]" />
                  ) : (
                    <Phone size={15} strokeWidth={1.5} className="shrink-0 text-[#C9A66B]" />
                  )}
                  {phone}
                </a>
              ))}
              {p.email && (
                <a
                  href={`mailto:${p.email}`}
                  data-testid={`practice-email-${p.id}`}
                  className="flex w-fit items-center gap-3 text-sm text-[#2D2D2D] transition-colors duration-300 hover:text-[#C9A66B]"
                >
                  <Mail size={15} strokeWidth={1.5} className="shrink-0 text-[#C9A66B]" />
                  {p.email}
                </a>
              )}
            </div>

            {p.note && (
              <span
                data-testid={`practice-note-${p.id}`}
                className="mt-auto pt-6 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C9A66B]"
              >
                {p.note}
              </span>
            )}
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
